import React from "react";
import { connect } from "react-redux";
import Layout from "../components/Layout";

import PropTypes from "prop-types";

import { setAlert } from "./../actions/alert";
import { loadUser, register } from "./../actions/auth";

import "./about.css";
import Alert from "../components/Alert";
import { Link, Navigate, useNavigate } from "react-router-dom";

const ConfirmYourSeat = ({
  setAlert,
  register,
  loadUser,
  auth: { isAuthenticated },
}) => {
  const navigate = useNavigate();

  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    password2: "",
  });

  if (isAuthenticated) {
    return <Navigate to={"/dashboard"} />;
  }

  const { name, email, phone, password, password2 } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const submitHandler = async (e) => {
    e.preventDefault();

    if (password !== password2) {
      setAlert("Passwords do not match", "danger");
    } else if (name === "" || email === "" || phone === "" || password === "") {
      setAlert("Please enter all fields", "danger");
    } else {
      const res = await register({ name, email, phone, password });
      if (res) {
        setAlert("Success", "success");
      }
    }
  };

  return (
    <Layout>
      <div className="slider-area">
        <div className="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center ">
              <div className="col-xxl-12">
                <div className="hero-caption hero-caption2">
                  <br />
                  <br />
                  <h2>Confirm your seat</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="contact-title">Enter your details</h2>
            </div>

            <div className="col-lg-8">
              <form
                className="form-contact contact_form"
                method="post"
                id="contactForm"
                onSubmit={submitHandler}
              >
                <Alert />
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control valid"
                        type="text"
                        value={name}
                        name="name"
                        onChange={(e) => onChange(e)}
                        placeholder="Enter your name"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control valid"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => onChange(e)}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="number"
                        value={phone}
                        onChange={(e) => onChange(e)}
                        name="phone"
                        placeholder="Enter Phone number"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="text"
                        value={password}
                        name="password"
                        onChange={(e) => onChange(e)}
                        placeholder="Enter Password"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="text"
                        value={password2}
                        name="password2"
                        onChange={(e) => onChange(e)}
                        placeholder="Confirm Password"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group mt-3">
                  <button
                    type="submit"
                    className="button button-contactForm btn_1"
                  >
                    Register
                  </button>
                  <Link to="/login" style={{ marginLeft: 20, color: "white" }}>
                    Already a user ? Login here.
                  </Link>
                </div>
              </form>
            </div>
            <div className="col-lg-3 offset-lg-1">
              <div className="media contact-info">
                <span className="contact-info__icon">
                  <i className="ti-home"></i>
                </span>
                <div className="media-body">
                  <h3>Sindh, Karachi, Pakistan</h3>
                  <p>Street abcs</p>
                </div>
              </div>
              <div className="media contact-info">
                <span className="contact-info__icon">
                  <i className="ti-tablet"></i>
                </span>
                <div className="media-body">
                  <h3>+01 (23) 456 789</h3>
                  <p>Mon to Fri 9am to 6pm</p>
                </div>
              </div>
              <div className="media contact-info">
                <span className="contact-info__icon">
                  <i className="ti-email"></i>
                </span>
                <div className="media-body">
                  <h3>atomos@atomos.com</h3>
                  <p>Send us your query anytime!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

ConfirmYourSeat.propTypes = {
  setAlert: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { setAlert, register, loadUser })(
  ConfirmYourSeat
);
